import Phaser from "phaser";
import { cst } from "../helpers/cst";
import $ from "jquery";
import buttonBehaviours from "../helpers/button-behaviours";
import { hideTextFields, showTextFields } from "../helpers/text-fields";

export default class Login extends Phaser.Scene {
  constructor() {
    super(cst.scenes.login);
  }

  preload() {}

  create() {
    this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, "bg-main");
    this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 75, "box-login");

    this.email = this.add
      .dom(this.cameras.main.width / 2, this.cameras.main.height / 2 - 300)
      .createFromCache("html-email");
    this.email = this.email.getChildByName("email");

    this.password = this.add
      .dom(this.cameras.main.width / 2, this.cameras.main.height / 2 - 225)
      .createFromCache("html-password");
    this.password = this.password.getChildByName("password");

    this.btnLogin = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 125, "btn-login")
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnLogin, () => {
          this.login();
        })
      );

    this.btnSignUp = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 50, "btn-sign-up")
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnSignUp, () => {
          this.scene.start(cst.scenes.signup);
        })
      );

    this.btnResetPassword = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 220, "btn-reset-password")
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnResetPassword, () => {
          this.scene.start(cst.scenes.sendemail);
        })
      );
  }

  upload() {}

  login() {
    let self = this;

    $.ajax({
      async: false,
      type: "post",
      url: "api/login.php",
      data: {
        email: this.email.value,
        password: this.password.value,
      },
      dataType: "JSON",
      success(response) {
        if (response[0] === 400) {
          hideTextFields([self.email, self.password]);
          buttonBehaviours.disableInteraction([
            self.btnLogin,
            self.btnSignUp,
            self.btnResetPassword,
          ]);

          const error = self.add.image(
            self.cameras.main.width / 2,
            self.cameras.main.height / 2 - 175,
            response[1]
          );

          setTimeout(() => {
            showTextFields([self.email, self.password]);
            buttonBehaviours.enableInteraction([
              self.btnLogin,
              self.btnSignUp,
              self.btnResetPassword,
            ]);

            error.destroy();
          }, 2000);
        } else {
          localStorage.setItem("jwt", response[1]);
          localStorage.setItem("user-id", response[2]);
          self.scene.start(cst.scenes.menu);
        }
      },
      error(error) {
        console.log(error);
      },
    }).responseJSON;
  }
}
